import { render, staticRenderFns } from "./ClosedCandidatures.vue?vue&type=template&id=f1562b02&"
import script from "./ClosedCandidatures.vue?vue&type=script&lang=js&"
export * from "./ClosedCandidatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports